// extracted by mini-css-extract-plugin
export default {"Link":"customLink__Link__Knju6"};